export const usedCars = "/product/find-by-category";
export const carsWithFilter = "/car";